export default "__VITE_ASSET__BoncDFYf__"